/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_BoldInputs */

const en_wc_tut_keys_bold = /** @type {(inputs: Wc_Tut_Keys_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bold the selection, or the word under the caret`)
};

/**
* | output |
* | --- |
* | "Bold the selection, or the word under the caret" |
*
* @param {Wc_Tut_Keys_BoldInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_bold = /** @type {((inputs?: Wc_Tut_Keys_BoldInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_BoldInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_bold(inputs)
});
export { wc_tut_keys_bold as "wc.tut.keys.bold" }